import * as React from 'react'
import { Link, browserHistory } from 'react-router'
import { Nav, NavItem, NavLink } from 'reactstrap'
import { AppView, AppMainView } from '../../../../components/AppView'
import AppHeader from '../../../../components/AppView/Header'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import { Routes } from '../../../../constants/Routes'
import { NoPermissionsResult } from '../../../../components/NoPermissionsResult'
import Helmet from 'react-helmet'
import { HelpLinkMenu } from '../../../../components/GrDropdown/HelpLinkMenu/HelpLinkMenu'
import { PermissionNames } from '@getgreenline/homi-shared'
import { BLAZE_COMPANY } from '../../../../constants/general'
import { HelpLinks } from '../../../../constants/ExternalLinks'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class DashboardWooCommerce extends React.Component<React.PropsWithChildren<Props>, {}> {
  componentDidMount() {
    this.props.currentCompanyStore!.productStore!.getCategories()
  }

  render() {
    const company = this.props.currentCompanyStore!.company!
    const categories = this.props.currentCompanyStore!.productStore!.flattenedCategories

    const areAPISettingsComplete =
      company.wooCommerceLocationId &&
      company.wooCommerceKey &&
      company.wooCommerceSecret &&
      company.wooCommerceSecret

    const categoryCount = categories
      ? categories.filter((c) => c.wooCommerceCategoryId).length
      : null

    return (
      <AppView column>
        <Helmet>
          <title>Integrations | WooCommerce</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        <AppHeader
          title='WooCommerce'
          onBackClick={() => browserHistory.push(Routes.DASHBOARD_INTEGRATIONS(company.id))}
          backVisible
        >
          <span className='spaced-button-wrapper'>
            <HelpLinkMenu
              helpLinkMenus={[
                {
                  href: HelpLinks.WOOCOMMERCE,
                  title: 'WooCommerce',
                },
              ]}
            />
          </span>
        </AppHeader>
        <AppMainView>
          {!company.permissions.canAccessWordPress && (
            <div className='text-muted'>
              WooCommerce integrations have not yet been enabled for your account.
              <br />
              Please contact {BLAZE_COMPANY} support to update your account.
            </div>
          )}

          {company.permissions.canAccessWordPress &&
            !this.props.currentUserStore!.hasPermissionAtEntity(
              PermissionNames.CAN_MANAGE_WOOCOMMERCE,
              company.id,
            ) && <NoPermissionsResult permissionName={PermissionNames.CAN_MANAGE_WOOCOMMERCE} />}

          {company.permissions.canAccessWordPress &&
            this.props.currentUserStore!.hasPermissionAtEntity(
              PermissionNames.CAN_MANAGE_WOOCOMMERCE,
              company.id,
            ) && (
              <>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={Routes.DASHBOARD_INTEGRATIONS_WOOCOMMERCE_PRODUCTS(company.id)}
                      active={window.location.pathname.includes('/wooCommerce/products')}
                    >
                      Products
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={Routes.DASHBOARD_INTEGRATIONS_WOOCOMMERCE_CATEGORIES(company.id)}
                      active={window.location.pathname.includes('/wooCommerce/categories')}
                    >
                      Categories{' '}
                      {categoryCount !== null && (
                        <span className='badge badge-secondary'>{categoryCount}</span>
                      )}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={Routes.DASHBOARD_INTEGRATIONS_WOOCOMMERCE_SETTINGS(company.id)}
                      active={window.location.pathname.includes('/wooCommerce/settings')}
                    >
                      API Settings{' '}
                      {areAPISettingsComplete ? (
                        <span className='fa fa-circle text-success ml-2' />
                      ) : (
                        <span className='fa fa-circle text-warning ml-2' />
                      )}
                    </NavLink>
                  </NavItem>
                </Nav>
                <br />
                {this.props.children}
              </>
            )}
          <div style={{ padding: '1rem' }} />
        </AppMainView>
      </AppView>
    )
  }
}
